import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62ad90fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trainCount" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trainCount-col1" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trainCount-col2" }, null, -1))
const _hoisted_4 = { class: "trainCount-col3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trainCount-col3-bg" }, null, -1))
const _hoisted_6 = { class: "trainCount-col3-title" }
const _hoisted_7 = { class: "trainCount-col3-title" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"trainCount-col4\" data-v-62ad90fa></div><div class=\"trainCount-col5\" data-v-62ad90fa></div><div class=\"line1\" data-v-62ad90fa><div data-v-62ad90fa></div><div data-v-62ad90fa></div></div><div class=\"line2\" data-v-62ad90fa><div data-v-62ad90fa></div><div data-v-62ad90fa></div></div><div class=\"line3\" data-v-62ad90fa><div data-v-62ad90fa></div><div data-v-62ad90fa></div></div><div class=\"line4\" data-v-62ad90fa><div data-v-62ad90fa></div><div data-v-62ad90fa></div></div>", 6)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, "装火车(" + _toDisplayString(_ctx.unit) + ")", 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.loadValue), 1),
      _createElementVNode("div", _hoisted_7, "卸火车(" + _toDisplayString(_ctx.unit) + ")", 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.unloadValue), 1)
    ]),
    _hoisted_8
  ]))
}